import { SettingFormRow } from "./SettingFormRow";

export const SchoolSettingForm = ({ users }) => {
  return (
    <>
      <div className="col-md-12">
        <p className="settingTitl">Admin Profile</p>
        <SettingFormRow users={users} />
      </div>
    </>
  );
};
